"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var react_1 = __importStar(require("react"));
var react_phone_number_input_1 = __importStar(require("react-phone-number-input"));
require("react-phone-number-input/style.css");
require("../../../index.css");
var TextInput = /** @class */ (function (_super) {
    __extends(TextInput, _super);
    function TextInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mobilePickerTimeout = null;
        _this.state = {
            countryCode: "",
            error: "",
        };
        _this.setAsyncState = function (newState) {
            return new Promise(function (resolve) { return _this.setState(newState, resolve); });
        };
        _this.componentDidMount = function () {
            _this.handleMountPhoneNumber();
        };
        _this.componentDidUpdate = function (prevProps) {
            if (JSON.stringify(prevProps.type) !== JSON.stringify(_this.props.type) ||
                JSON.stringify(prevProps.mobilePicker) !==
                    JSON.stringify(_this.props.mobilePicker)) {
                _this.handleMountPhoneNumber();
            }
        };
        _this.handleOnChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
        };
        _this.handleCellOnBlur = function () {
            var _a, _b;
            if (((_a = _this.props.cellInput) === null || _a === void 0 ? void 0 : _a.active) && _this.props.cellInput.onBlur) {
                (_b = _this.props.cellInput) === null || _b === void 0 ? void 0 : _b.onBlur();
            }
        };
        _this.handleMountPhoneNumber = function () {
            if (_this.props.type === "mobile" &&
                _this.props.mobilePicker &&
                !_this.state.countryCode) {
                _this.handleGetPhoneNumber();
            }
        };
        _this.handleGetPhoneNumber = function (value) {
            var clonedValue = value !== null && value !== void 0 ? value : _this.props.value;
            if (clonedValue.startsWith("+")) {
                var phoneNumber = (0, react_phone_number_input_1.parsePhoneNumber)(clonedValue);
                if (phoneNumber) {
                    if (phoneNumber.country && (0, react_phone_number_input_1.isSupportedCountry)(phoneNumber.country)) {
                        var callingCode = "+" + (0, react_phone_number_input_1.getCountryCallingCode)(phoneNumber.country);
                        _this.setState({ countryCode: callingCode });
                        return clonedValue;
                    }
                }
            }
            else {
                _this.setState({ countryCode: "+60" });
                return clonedValue;
            }
        };
        _this.handleChangeCountryCode = function (value) {
            var currentPhone = _this.props.value;
            var inputPhone = "";
            inputPhone = currentPhone.substring(_this.state.countryCode.length);
            inputPhone = inputPhone.replace(/[^0-9]/g, "");
            inputPhone = value + inputPhone;
            _this.setState({ countryCode: value });
            _this.handleMobileEvent(inputPhone, true);
        };
        _this.handleMobileTextOnChange = function (e) {
            if (_this.mobilePickerTimeout)
                clearTimeout(_this.mobilePickerTimeout);
            if (e.target.value.startsWith("+")) {
                var newInput = e.target.value.substring(1);
                newInput = newInput.replace(/[^0-9]/g, "");
                _this.handleMobileEvent("+" + newInput);
                _this.mobilePickerTimeout = setTimeout(function () {
                    var phoneNumber = _this.handleGetPhoneNumber(e.target.value);
                    if (phoneNumber !== undefined) {
                        _this.handleMobileEvent(phoneNumber, true);
                    }
                }, 500);
            }
            else if (e.target.value === "") {
                _this.handleGetPhoneNumber(e.target.value);
                _this.handleMobileEvent(e.target.value, true);
            }
            else {
                var newInput = e.target.value.replace(/[^0-9]/g, "");
                _this.handleMobileEvent(newInput);
            }
        };
        _this.handleMobileEvent = function (inputValue, updateCountry) {
            var castedValue = "";
            castedValue = updateCountry
                ? inputValue
                : _this.state.countryCode + inputValue;
            var customEvent = {
                target: {
                    id: _this.props.id,
                    value: castedValue,
                },
            };
            _this.handleOnChange(customEvent);
        };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var testCond, error, emailFilter, textFilter, passwordFilter, phoneFilterMY_1, phoneFilterBN_1, phoneFormat_1, eachTestCond_1, phoneNumber;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        testCond = false;
                        error = "";
                        if (!this.props.optional) {
                            // INFO : Regrex Validation
                            /* eslint-disable */
                            switch (this.props.type) {
                                case "email":
                                    emailFilter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                                    testCond = emailFilter.test(this.props.value);
                                    error = "Please input the correct email format";
                                    break;
                                case "text":
                                    textFilter = /^[^\s]+(\s+[^\s]+)*\s*\s?$/;
                                    testCond = textFilter.test(this.props.value);
                                    error = "Please input a text";
                                    break;
                                case "password":
                                    passwordFilter = /^[A-Za-z\d#$@!%&*?]{6,30}$/;
                                    testCond = passwordFilter.test(this.props.value);
                                    error = "Please input at least 6-30 characters";
                                    break;
                                case "number":
                                    testCond =
                                        this.props.value !== null &&
                                            this.props.value !== "" &&
                                            !isNaN(this.props.value) &&
                                            Number(this.props.value) >= 0;
                                    error = "Please input a number";
                                    break;
                                case "mobile":
                                    phoneFilterMY_1 = /^(\+60)-*[0-9]{8,10}$/;
                                    phoneFilterBN_1 = /^(\+673)-*[0-9]{7}$/;
                                    phoneFormat_1 = "(eg +60123456789)";
                                    if (this.props.mobilePicker) {
                                        phoneFormat_1 = "for your country number";
                                        testCond =
                                            (0, react_phone_number_input_1.isPossiblePhoneNumber)(this.props.value) &&
                                                (0, react_phone_number_input_1.isValidPhoneNumber)(this.props.value);
                                    }
                                    else if (this.props.mobileWhitelist &&
                                        this.props.mobileWhitelist.length > 0) {
                                        eachTestCond_1 = false;
                                        this.props.mobileWhitelist.map(function (eachWhitelist) {
                                            switch (eachWhitelist) {
                                                case "MY":
                                                    phoneFormat_1 = "(eg +60123456789)";
                                                    if (phoneFilterMY_1.test(_this.props.value))
                                                        eachTestCond_1 = true;
                                                    break;
                                                case "BN":
                                                    phoneFormat_1 = "(eg +6731234567)";
                                                    if (phoneFilterBN_1.test(_this.props.value))
                                                        eachTestCond_1 = true;
                                                    break;
                                            }
                                        });
                                        testCond = eachTestCond_1;
                                    }
                                    else {
                                        phoneNumber = (0, react_phone_number_input_1.parsePhoneNumber)(this.props.value);
                                        if (phoneNumber) {
                                            if (phoneNumber.country &&
                                                (0, react_phone_number_input_1.isSupportedCountry)(phoneNumber.country) &&
                                                (0, react_phone_number_input_1.isPossiblePhoneNumber)(this.props.value) &&
                                                (0, react_phone_number_input_1.isValidPhoneNumber)(this.props.value))
                                                testCond = true;
                                        }
                                    }
                                    error = "Please input the correct format ".concat(phoneFormat_1);
                                    break;
                                default:
                                    error = "Please input the correct format";
                                    if (this.props.pattern) {
                                        testCond = this.props.pattern.test(this.props.value);
                                    }
                                    break;
                            }
                            /* eslint-enable */
                        }
                        else {
                            testCond = true;
                        }
                        if (!!testCond) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setAsyncState({ error: error })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.setAsyncState({ error: "" })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, testCond];
                }
            });
        }); };
        _this.renderMobilePickerInput = function (defaultClassName) {
            var _a, _b;
            var inputValue = _this.props.value.startsWith("+")
                ? _this.props.value.substring(_this.state.countryCode.length)
                : _this.props.value;
            return (react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement(react_phone_number_input_1.default, { disabled: _this.props.disabled, value: _this.state.countryCode, defaultCountry: (_b = (_a = (0, react_phone_number_input_1.parsePhoneNumber)(_this.props.value)) === null || _a === void 0 ? void 0 : _a.country) !== null && _b !== void 0 ? _b : "MY", countryCallingCodeEditable: false, readOnly: true, international: true, withCountryCallingCode: true, className: "mt-1 text-base text-gray-900", onChange: _this.handleChangeCountryCode }),
                react_1.default.createElement("input", { id: _this.props.id, disabled: _this.props.disabled, className: defaultClassName, value: inputValue, maxLength: _this.props.maxLength, placeholder: _this.props.placeholder, autoComplete: _this.props.autoComplete, onChange: _this.handleMobileTextOnChange, type: _this.props.type })));
        };
        return _this;
    }
    TextInput.prototype.render = function () {
        var _a, _b, _c;
        var defaultPadding = "px-5 py-3";
        if (this.props.size === "small") {
            defaultPadding = "px-3 py-2";
        }
        else if (this.props.size === "mini" || ((_a = this.props.cellInput) === null || _a === void 0 ? void 0 : _a.active)) {
            defaultPadding = "p-2";
        }
        var defaultFontSize = "text-base";
        if ((_b = this.props.cellInput) === null || _b === void 0 ? void 0 : _b.active) {
            defaultFontSize = "text-sm";
        }
        var defaultBorder = "border border-gray-300";
        if (((_c = this.props.cellInput) === null || _c === void 0 ? void 0 : _c.active) && !this.state.error) {
            defaultBorder = "border-0 hover:border hover:border-gray-300";
        }
        var defaultClassName = "block w-full ".concat(defaultBorder, " rounded-md mt-1 ").concat(defaultPadding, " ").concat(defaultFontSize, " text-gray-900 placeholder-gray-300 focus:border focus:border-primary-500 focus:outline-none focus:ring-0");
        if (this.state.error) {
            defaultClassName += " mb-0.5 border-red-300";
        }
        if (this.props.inputClassName) {
            defaultClassName += " ".concat(this.props.inputClassName);
        }
        return (react_1.default.createElement("div", { className: this.props.containerClassName },
            react_1.default.createElement("label", { className: "block text-sm font-medium text-gray-700" },
                this.props.label,
                " ",
                this.props.labelExtra),
            this.props.subLabel && (react_1.default.createElement("label", { className: "block text-xs font-medium text-gray-500 mb-2" }, this.props.subLabel)),
            react_1.default.createElement("div", null, this.props.type === "mobile" &&
                this.props.mobilePicker &&
                this.state.countryCode ? (this.renderMobilePickerInput(defaultClassName)) : (react_1.default.createElement("input", { id: this.props.id, disabled: this.props.disabled, className: defaultClassName, value: this.props.value, maxLength: this.props.maxLength, placeholder: this.props.placeholder, autoComplete: this.props.autoComplete, onChange: this.handleOnChange, type: this.props.type, autoFocus: this.props.autoFocus, onBlur: this.handleCellOnBlur.bind(false) }))),
            this.state.error && (react_1.default.createElement("span", { className: "text-red-500 text-sm" }, this.state.error))));
    };
    return TextInput;
}(react_1.Component));
exports.TextInput = TextInput;
//# sourceMappingURL=index.js.map